module.exports = __webpack_public_path__ + "img/icono-experiencia-1.9945d026.svg";